var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundPatternGoldArch111(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 764,
    height: 380,
    viewBox: "0 0 764 380",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2346_106)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 389C0 174.155 171.034 0 382 0C592.976 0 764 174.155 764 389C764 459.46 745.608 525.557 713.433 582.556L511.876 434.196H584.776L698.141 517.665C713.763 477.881 722.375 434.465 722.375 389C722.375 197.576 569.977 42.4019 382 42.4019C194.023 42.4019 41.6379 197.576 41.6379 389C41.6379 580.415 194.023 735.598 382 735.598C479.151 735.598 566.797 694.15 628.814 627.665L662.703 652.852C592.899 729.815 492.978 778 382 778C171.034 778 0 603.829 0 389Z",
    fill: "#BDA76E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2346_106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 380,
    height: 764,
    fill: "white",
    transform: "matrix(0 -1 1 0 0 380)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundPatternGoldArch111);
export default __webpack_public_path__ + "static/media/background-pattern-gold-arch-1-1-1.12cd6aff66b89649be6769f469553178.svg";
export { ForwardRef as ReactComponent };